const divFormActions = {
  fileError: 'Wait for all files to upload'
};

export default divFormActions;
